<template>

    <TemplateBasic 
      v-bind:breadcrumb="breadcrumb"
      v-bind:permission="permission">

      <div class="row form-group">

        <div class="col">
          <AppAddButton v-bind:permission="permission">
          <button @click.prevent="onAddButtonClick" href="#" class="btn btn-rounded btn-info btn-block-xs-only">
            Assign New Role
          </button>
          </AppAddButton>
        </div>
        
      </div>

      <AppFilter 
        ref="pageFilter" 
        filterKey="userID"
        v-on:filter-data-change="onFilterDataChange" />
      
      <AppTable 
        ref="pageTable" 
        v-bind:tableParameter="PARAM" 
        v-bind:permission="permission"
        v-on:table-data-click="onTableDataClick" 
        v-on:table-page-change="onTablePageChange" />

      <TemplateFeedback ref="pageFeedback" />

      <AppModalForm 
        ref="pageModal" 
        v-bind:formParameter="PARAM" 
        v-bind:permission="permission"
        v-on:modal-data-add="onModalAddDataClick"
        v-on:modal-data-edit="onModalEditDataClick"
        v-on:modal-data-delete="onModalDeleteDataClick" />

    </TemplateBasic>

</template>

<script>
import TemplateBasic from "@/components/Template/TemplateBasic";
import TemplateButton from "@/components/Template/TemplateButton";
import TemplateFeedback from "@/components/Template/TemplateFeedback";
import AppSearch from "@/components/App/AppSearch";
import AppPaging from "@/components/App/AppPaging";
import AppFilter from "@/components/App/AppFilter";
import AppTable from "@/components/App/AppTable";
import AppAddButton from "@/components/App/AppAddButton";
import AppModalForm from "@/components/App/AppModalForm";
import validation from "@/components/Utility/Validation"
import helper from "@/components/Utility/Helper"

var querystring = require('querystring');

const PARAM = [
  {
    key: '_index',
    index: true,
  },
  {
    key: 'userID',
    text: 'User',
    table_hide: true,
    form_select: {
      data: [],
      formatSelectOptionText: (dataItem) => dataItem.name + ' (' + dataItem.email + ')'
    },
  },
  {
    key: 'userName',
    text: 'User',
    table_popup: true,
    form_hide: true,
  },
  {
    key: 'userEmail',
    text: 'Email',
    form_hide: true,
  },
  {
    key: 'roleID',
    text: 'Role',
    table_hide: true,
    form_select: {
      data: [],
      formatSelectOptionText: (dataItem) => dataItem.title
    },
  },
  {
    key: 'title',
    text: 'Role',
    table_custom: function(dataResult, dataIndex, dataParameter, parameterIndex) {
      let parameterItem = dataParameter[parameterIndex];
      let dataItem = dataResult[dataIndex];
      return `<a href="${helper.WEB_URL}/internalRoleForm?roleID=${dataItem.roleID}" target="_blank">${dataItem.title}</a>`;
    },
    form_hide: true,
  },
];
const PARAM_MAP = helper.transformParamToMap(PARAM);


export default {
  name: "PageUserRules",
  components: {
    TemplateBasic,
    TemplateButton,
    AppSearch,
    AppPaging,
    AppFilter,
    AppTable,
    AppAddButton,
    AppModalForm,
    TemplateFeedback,
  },
  data () {
    return {
      helper: helper,
      permission : null,
      breadcrumb : [
        { name: 'Home', url: helper.WEB_URL },
        { name: 'Administration' },
        { name: 'People Management' },
        { name: 'Internal User Role' },
      ],

      PARAM,
      PARAM_MAP,

      pageRole: null,
      pageUser: null,
    }
  },
  mounted() {
    if(!helper.hasViewPermission(this.permission = helper.getPermission(this))) {
      return;
    }

    this.$refs['pageModal'].modalCanEdit = false;
    this.$refs['pageFilter'].formatFilterOptionText = (dataItem) => dataItem.name + ' (' + dataItem.email + ')';
    
    // this.loadCity();
    this.loadRole();
  },
  methods: {
    loadRole() {
      this.$refs['pageTable'].setTableLoading('Loading role data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/roles/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageRole = response.data;
          helper.inputSelectSetOption(this.PARAM_MAP['roleID'], response.data);
          this.loadUser();
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'role data'));
        })
    },
    loadUser() {
      this.$refs['pageTable'].setTableLoading('Loading user data...');
      this.$http
        .get(
          helper.SERVER_URL + '/api2/user/',
          helper.createAxiosConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.pageUser = response.data;
          this.$refs['pageFilter'].setFilterDataWithValueIfFirstLoad(response.data, this.$route.query.userID);
          helper.inputSelectSetOption(this.PARAM_MAP['userID'], response.data);
          this.loadData();
        })
        .catch(error => {
          this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'user data'));
        })
    },
    async loadData() {
      this.$refs['pageTable'].setTableLoading('Loading user role data...');
      // this.$http
      //   .get(
      //     this.getUrl(),
      //     helper.createAxiosConfig()
      //   )
      //   .then(response => {
      //     response.data.forEach(k => {
      //       k['user'] = this.pageUser.find(j => j.id === k.userID);
      //       k['role'] = this.pageRole.find(j => j.id === k.roleID);
      //     });
      //     this.$refs['pageTable'].setTableData(response.data);
      //   })
      //   .catch(error => {
      //     this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'user role data'));
      //   })

      let temp = [];
      for(let user of this.pageUser) {
        if(!helper.compareID(user.id, this.$refs['pageFilter'].filterValue)) {
          continue;
        }

        await this.$http
          .get(
            this.getUrl(user.id),
            helper.createAxiosConfig()
          )
          .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response, true);
            response.data.forEach(k => {
              k['userID'] = user.id;
              k['userName'] = user.name;
              k['userEmail'] = user.email;
              // k['role'] = this.pageRole.find(j => j.id === k.roleID) || {};
              // k['roleID'] = k['role'].id;
              // k['roleTitle'] = k['role'].title;
            });
            temp = temp.concat(response.data)
          })
          .catch(error => {
            this.$refs['pageTable'].setTableError(helper.parseAxiosErrorMessage(this, error, 'loading', 'user role data'));
            return;
          })
      }

      this.$refs['pageTable'].setTableData(temp);
    },

    getUrl(userID) {
      let url = helper.SERVER_URL + '/api2';
      if(userID) {
        url += '/user/' + userID;
      }
      url += '/roles/';

      return url;
    },

    onTablePageChange() {
      this.loadData();
    },
    onSearchChange(dataIndex) {
      this.$refs['pageTable'].setCurrentPage(1);
      this.loadData();
    },
    onFilterDataChange(dataIndex) {
      this.loadData();
    },

    onAddButtonClick() {
      this.$refs['pageFeedback'].setFeedbackMessage();

      let defaultData = this.$refs['pageModal'].$refs['modalForm'].getFormDefaultData();
      defaultData['userID'] = this.$refs['pageFilter'].filterValue;

      this.$refs['pageModal'].setModalOpen(true, 'Add User Role', defaultData);
    },
    onTableDataClick(tableData, tableDataIndex) {
      this.$refs['pageFeedback'].setFeedbackMessage();
      this.$refs['pageModal'].setModalOpen(false, 'Edit role for ' + tableData[tableDataIndex]['userName'], tableData[tableDataIndex]);
    },

    onModalAddDataClick(selectedData) {
      let role = this.pageRole.find(k => helper.compareID(k.id, selectedData['roleID']));
      let user = this.pageUser.find(k => helper.compareID(k.id, selectedData['userID']));
      let feedbackItem = role.title + ' role to ' + user.name;
      this.$refs['pageModal'].setModalLoading('Adding ' + feedbackItem);
      this.$http
        .post(
          this.getUrl(selectedData.userID),
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.$refs['pageFilter'].setFilterValue(selectedData.carparkID);
          this.upsertDataComplete('Successfully added ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'adding', feedbackItem));
        })
    },
    onModalEditDataClick(selectedData) {
      let role = this.pageRole.find(k => helper.compareID(k.id, selectedData['roleID']));
      let user = this.pageUser.find(k => helper.compareID(k.id, selectedData['userID']));
      let feedbackItem = role.title + ' role to ' + user.name;
      this.$refs['pageModal'].setModalLoading('Setting ' + feedbackItem);
      this.$http
        .put(
          this.getUrl(selectedData.userID) + selectedData.id,
          querystring.stringify(selectedData),
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully set ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'setting', feedbackItem));
        })
    },
    onModalDeleteDataClick(selectedData) {
      let role = this.pageRole.find(k => helper.compareID(k.id, selectedData['roleID']));
      let user = this.pageUser.find(k => helper.compareID(k.id, selectedData['userID']));
      let feedbackItem = role.title + ' role to ' + user.name;
      this.$refs['pageModal'].setModalLoading('Deleting ' + feedbackItem);
      this.$http
        .delete(
          this.getUrl(selectedData.userID) + selectedData.roleID,
          helper.createAxiosFormConfig()
        )
        .then(response => {
          let resultMeta = helper.processAxiosResponse(this, response);
          this.upsertDataComplete('Successfully delete ' + feedbackItem);
        })
        .catch(error => {
          this.$refs['pageModal'].setModalError(helper.parseAxiosErrorMessage(this, error, 'deleting', feedbackItem));
        })
    },
    upsertDataComplete(message) {
      this.$refs['pageFilter'].setFilterValue(this.$refs['pageModal'].$refs['modalForm'].formData.userID);
      this.$refs['pageModal'].setModalClose();
      this.$refs['pageFeedback'].setFeedbackMessage(message);
      this.loadData();
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Page/Admin/PageUserRole.vue